import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Field/Field.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function cls(...parts) {
  return parts.filter(Boolean).join(" ");
}
var fieldVariants = cva("buyscout-field", {
  variants: {
    layout: {
      inline: "",
      stacked: "buyscout-field--stacked"
    },
    labelWidth: {
      sm: "buyscout-field--label-width-sm",
      md: "buyscout-field--label-width-md"
    },
    align: {
      center: "buyscout-field--align-center",
      start: "buyscout-field--align-start"
    }
  },
  defaultVariants: {
    layout: "inline",
    labelWidth: "md",
    align: "center"
  }
});
function Field({
  ref,
  label,
  layout,
  labelWidth,
  align,
  className,
  labelClassName,
  htmlFor,
  labelId,
  children,
  ...props
}) {
  const LabelTag = htmlFor ? "label" : "span";
  return /* @__PURE__ */ jsxs("div", { ref, className: fieldVariants({ layout, labelWidth, align, className }), ...props, children: [
    /* @__PURE__ */ jsx(LabelTag, { id: labelId, htmlFor, className: cls("buyscout-field__label", labelClassName), children: label }),
    /* @__PURE__ */ jsx("div", { className: "buyscout-field__value", children })
  ] });
}
Field.displayName = "Field";
export {
  Field
};
//# sourceMappingURL=Field.mjs.map